var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartOver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.138 19A7.687 7.687 0 0020 11.5 7.687 7.687 0 0012.138 4a7.687 7.687 0 00-7.862 7.5v3.875l-2.359-2.25L1 14l3.931 3.75L8.862 14l-.917-.875-2.359 2.25V11.5a6.406 6.406 0 016.552-6.25 6.406 6.406 0 016.552 6.25 6.406 6.406 0 01-6.552 6.25z"
  })));
}
export default SvgStartOver;